module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Media/CD-2cd9ad08272baaef57d82f8c5743a78e1f60e7261ed2090b64774c99cc99b40b.svg";